(() => {
    const shopRoot = window.Shopify?.routes?.root || '/';
    const rootPath = shopRoot.endsWith('/') ? shopRoot : shopRoot + '/';

    const parseSize = (value) => {
      const text = String(value || '').toUpperCase().replace(/\s+/g, ' ');
      const match = text.match(/\b(LT\s*)?(\d{3}|\d{1,2}\.\d{2})\s*(?:\/\s*(\d{2,3}))?\s*R\s*(\d{2,3})\s*(C)?\b/);
      if (!match) return null;
      const prefix = match[1] ? 'LT' : '';
      const width = match[2].replace(/\s/g, '');
      const profile = match[3] || '';
      const rim = match[4];
      const construction = match[5] || '';
      return {
        key: [width, profile, rim, construction].join('|'),
        width,
        profile,
        rim,
        prefix,
        construction,
        query: profile ? `${width}/${profile} R${rim}` : `${width} R${rim}${construction}`,
        compactQuery: profile ? `${width}/${profile}R${rim}` : `${width}R${rim}${construction}`,
        label: `${width}${profile ? '/' + profile : ''} R${rim}${construction}`
      };
    };

    const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const knownBrands = ['bridgestone','michelin','goodyear','firestone','pirelli','continental','dunlop','yokohama','hankook','kumho','toyo','mirage','roadwing','windforce','milemax','goodride','wanli','maxxis','falken','cooper','nexen','nankang','sailun','tracmax','kapsen','lanvigator','triangle','petlas','blacklion','sunfull','royal black','double king','powertrac','hifly','ovation','westlake','linglong','armstrong','general tire'];

    const brandFromTitle = (title) => {
      const cleanTitle = normalize(title);
      return knownBrands.find((brand) => cleanTitle.includes(normalize(brand))) || '';
    };

    const brandFor = (vendor, title) => {
      const cleanVendor = normalize(vendor);
      if (cleanVendor && cleanVendor !== 'nueva emar' && cleanVendor !== 'sin marca') return String(vendor).trim();
      return brandFromTitle(title) || String(vendor || '').trim();
    };

    const extractCardData = (doc) => {
      const results = new Map();
      const anchors = Array.from(doc.querySelectorAll('a[href*="/products/"]'));
      anchors.forEach((anchor) => {
        let url;
        try { url = new URL(anchor.getAttribute('href'), location.origin); } catch (error) { return; }
        const match = url.pathname.match(/\/products\/([^/]+)/);
        if (!match) return;
        const handle = decodeURIComponent(match[1]);
        if (results.has(handle)) return;
        const card = anchor.closest('.card-wrapper, .grid__item, .emar-product-card, .product-card') || anchor.parentElement;
        const titleNode = card?.querySelector('.card__heading a, .card__heading, h2, h3, [id^="title--"]');
        const title = (titleNode?.textContent || anchor.getAttribute('aria-label') || anchor.textContent || '').replace(/\s+/g, ' ').trim();
        if (!title) return;
        const imageNode = card?.querySelector('.card__media img, .media img, img');
        const image = imageNode?.getAttribute('data-src') || imageNode?.getAttribute('src') || imageNode?.getAttribute('srcset')?.split(',').pop()?.trim().split(' ')[0] || '';
        const vendor = card?.querySelector('.caption-with-letter-spacing, [data-product-vendor]')?.textContent?.trim() || card?.querySelector('[data-product-vendor]')?.getAttribute('data-product-vendor') || '';
        const priceNode = card?.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular, .price-item--sale, .price-item--regular, .price-item');
        const price = (priceNode?.textContent || '').replace(/\s+/g, ' ').trim();
        results.set(handle, { handle, path: url.pathname, title, vendor, image, price });
      });
      return results;
    };

    const readSearch = async (query) => {
      const all = new Map();
      for (let page = 1; page <= 6; page += 1) {
        const url = new URL(rootPath + 'search', location.origin);
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', query);
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('limit', '50');
        if (page > 1) url.searchParams.set('page', String(page));
        const response = await fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) break;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        extractCardData(doc).forEach((value, key) => all.set(key, value));
        const next = doc.querySelector('.pagination__item--next[href], .pagination a[rel="next"][href], a[rel="next"][href]');
        if (!next || page === 6) break;
      }
      return all;
    };

    const makeNode = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    };

    const init = async (root) => {
      if (!root || root.dataset.emarLoaded) return;
      root.dataset.emarLoaded = 'true';
      const currentSize = parseSize(root.dataset.currentTitle);
      if (!currentSize) return;
      const currentHandle = root.dataset.currentHandle;
      const currentBrand = normalize(brandFor(root.dataset.currentVendor, root.dataset.currentTitle));
      const track = root.querySelector('[data-emar-size-track]');
      const viewport = root.querySelector('[data-emar-size-viewport]');
      const label = root.querySelector('[data-emar-size-label]');
      const count = root.querySelector('[data-emar-size-count]');
      const prev = root.querySelector('[data-emar-size-prev]');
      const next = root.querySelector('[data-emar-size-next]');
      if (!track || !viewport) return;

      try {
        const queries = Array.from(new Set([currentSize.query, currentSize.compactQuery]));
        const searchSets = await Promise.all(queries.map(readSearch));
        const candidates = new Map();
        searchSets.forEach((set) => set.forEach((value, key) => candidates.set(key, value)));
        const exactSize = Array.from(candidates.values()).filter((item) => {
          const itemSize = parseSize(item.title);
          if (!itemSize || itemSize.key !== currentSize.key || item.handle === currentHandle) return false;
          const otherBrand = normalize(brandFor(item.vendor, item.title));
          return !currentBrand || !otherBrand || otherBrand !== currentBrand;
        });

        const details = await Promise.all(exactSize.map(async (item) => {
          try {
            const response = await fetch(rootPath + 'products/' + encodeURIComponent(item.handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
            if (!response.ok) return item;
            const data = await response.json();
            return {
              ...item,
              title: data.title || item.title,
              vendor: data.vendor || item.vendor,
              image: data.featured_image || data.images?.[0] || item.image,
              available: data.available !== false
            };
          } catch (error) { return item; }
        }));

        const products = details.filter((item) => {
          const itemSize = parseSize(item.title);
          if (!itemSize || itemSize.key !== currentSize.key || item.handle === currentHandle) return false;
          const otherBrand = normalize(brandFor(item.vendor, item.title));
          return !currentBrand || !otherBrand || otherBrand !== currentBrand;
        });
        if (!products.length) return;
        root.dataset.productCount = String(products.length);

        if (label) label.textContent = currentSize.label;
        if (count) count.textContent = `${products.length} ${products.length === 1 ? 'opción' : 'opciones'}`;
        products.forEach((item) => {
          const li = makeNode('li', 'emar-size-carousel__item');
          const link = makeNode('a', 'emar-size-card');
          link.href = item.path || rootPath + 'products/' + encodeURIComponent(item.handle);
          link.setAttribute('aria-label', `${item.title} · ${brandFor(item.vendor, item.title)}`);
          const media = makeNode('div', 'emar-size-card__media');
          if (item.image) {
            const image = document.createElement('img');
            image.src = item.image;
            image.alt = item.title;
            image.loading = 'lazy';
            image.decoding = 'async';
            media.appendChild(image);
          } else {
            media.appendChild(makeNode('span', 'emar-size-card__placeholder', 'EMAR'));
          }
          if (item.available === false) media.appendChild(makeNode('span', 'emar-size-card__stock', 'Sin stock'));
          const body = makeNode('div', 'emar-size-card__body');
          body.appendChild(makeNode('span', 'emar-size-card__brand', brandFor(item.vendor, item.title) || 'Otra marca'));
          body.appendChild(makeNode('h3', 'emar-size-card__name', item.title));
          body.appendChild(makeNode('span', 'emar-size-card__measure', currentSize.label));
          if (item.price) body.appendChild(makeNode('strong', 'emar-size-card__price', item.price));
          const cta = makeNode('span', 'emar-size-card__cta', 'Ver neumático');
          cta.appendChild(makeNode('span', '', '→'));
          body.appendChild(cta);
          link.append(media, body);
          li.appendChild(link);
          track.appendChild(li);
        });

        root.hidden = false;
        const updateControls = () => {
          const maxScroll = viewport.scrollWidth - viewport.clientWidth - 2;
          if (prev) prev.disabled = viewport.scrollLeft <= 2;
          if (next) next.disabled = viewport.scrollLeft >= maxScroll;
          if (products.length <= 2) {
            if (prev) prev.hidden = true;
            if (next) next.hidden = true;
          }
        };
        prev?.addEventListener('click', () => viewport.scrollBy({ left: -viewport.clientWidth * .85, behavior: 'smooth' }));
        next?.addEventListener('click', () => viewport.scrollBy({ left: viewport.clientWidth * .85, behavior: 'smooth' }));
        viewport.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls, { passive: true });
        updateControls();
      } catch (error) {
        root.dataset.emarError = 'true';
      }
    };

    document.querySelectorAll('[data-emar-same-size]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll?.('[data-emar-same-size]').forEach(init);
    });
  })();
